export default "__VITE_ASSET__158216a2__"